module.exports = __webpack_public_path__ + "portal/static/img/unnamed.fead835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-bank/unnamed.png
// module id = vVu7
// module chunks = 67